export default __webpack_public_path__ + "static/media/030-3.03bd0ac3.svg";